import React from 'react'
import TopContent from '../components/organisms/topContent/topContent'
import PageLayout from '../components/templates/page-layout/page-layout'
import useMediaQuery from '../utils/useMediaQuery'

const TopJugadoras = () => {
  const isMobile = useMediaQuery()

  return (
    <>
      {process.env.LOCALE !== 'es-BO' ? (
        <PageLayout hiddenNav={true}>
          <TopContent mobile={isMobile} />
        </PageLayout>
      ) : (
        <h1>PAGINA NO ENCONTRADA, REGRESA A NUESTRO SITIO.</h1>
      )}
    </>
  )
}

export default TopJugadoras
